// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "./theme/theme";
import toastr from "toastr"
window.toastr = toastr
import "trix"
import "@rails/actiontext"
import select2 from "select2"
